import React from 'react';
import { Card } from 'antd';
import { TruckOutlined } from '@ant-design/icons';

const FulfillmentChannelProgress = ({ fulfillmentData, color = '#13c2c2' }) => {
    const afnPercentage = fulfillmentData?.AFN?.percentage || 0;
    const mfnPercentage = fulfillmentData?.MFN?.percentage || 0;
    const totalOrders = fulfillmentData?.total || 0;
    const afnCount = fulfillmentData?.AFN?.count || 0;
    const mfnCount = fulfillmentData?.MFN?.count || 0;

    return (
        <Card
            size="small"
            style={{
                background: '#fff',
                borderRadius: '12px',
                boxShadow: '2px 4px 9px -5px rgba(0,0,0,0.08)',
                border: '1px solid #f5f5f5',
                height: '72px',
                transition: 'box-shadow 0.2s, border 0.2s',
            }}
            styles={{
                body: {
                    padding: '5px 14px',
                    height: '100%'
                }
            }}
        >
            {/* Title */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '8px'
            }}>
                <span style={{
                    color: '#8c8c8c',
                    fontSize: '11px',
                    fontWeight: '500'
                }}>
                    Fulfillment ({totalOrders} orders)
                </span>
                <TruckOutlined style={{
                    fontSize: '12px',
                    color: color
                }} />
            </div>

            {/* Multi-color Progress Bar */}
            <div style={{
                display: 'flex',
                height: '6px',
                borderRadius: '3px',
                overflow: 'hidden',
                marginBottom: '6px',
                backgroundColor: '#f5f5f5'
            }}>
                <div style={{
                    width: `${afnPercentage}%`,
                    backgroundColor: '#FF9900', // Amazon orange for FBA
                    transition: 'all 0.3s ease'
                }} />
                <div style={{
                    width: `${mfnPercentage}%`,
                    backgroundColor: '#1890ff', // Blue for FBM
                    transition: 'all 0.3s ease'
                }} />
            </div>

            {/* Legend */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '2px'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '2px'
                }}>
                    <div style={{
                        width: '4px',
                        height: '4px',
                        borderRadius: '50%',
                        backgroundColor: '#FF9900'
                    }} />
                    <span style={{
                        fontSize: '11px',
                        fontWeight: '500'
                    }}>
                        <span style={{ color: '#FF9900' }}>FBA</span>{' '}
                        <span style={{ color: '#8c8c8c', fontWeight: 'bold' }}>{afnCount}</span>{' '}
                        <span style={{ color: '#8c8c8c', fontWeight: 'bold' }}>({afnPercentage.toFixed(0)}%)</span>
                    </span>
                </div>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '2px'
                }}>
                    <div style={{
                        width: '4px',
                        height: '4px',
                        borderRadius: '50%',
                        backgroundColor: '#1890ff'
                    }} />
                    <span style={{
                        fontSize: '11px',
                        fontWeight: '500'
                    }}>
                        <span style={{ color: '#1890ff' }}>FBM</span>{' '}
                        <span style={{ color: '#8c8c8c', fontWeight: 'bold' }}>{mfnCount}</span>{' '}
                        <span style={{ color: '#8c8c8c', fontWeight: 'bold' }}>({mfnPercentage.toFixed(0)}%)</span>
                    </span>
                </div>
            </div>
        </Card>
    );
};

export default FulfillmentChannelProgress;
